import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import PegaMasResults from '../../components/PegaMas/PegaMasResults/PegaMasResults';
import ErrorPage from '../../components/shared/ErrorPage';
import LoadingSpinner from "../../components/shared/Loading/LoadingSpinner";
import { games } from '../../constants/games';
import usePegaMas from '../../hooks/useJogos';
import { parseTimeToDate } from '../../utils';
import { videoUrls } from "../../constants/pegaMasMultimedia";
import './styles.css';
import { ResultAnimation } from '../../components/PegaMas/ResultAnimation/result-animation';
import { getVideoFromDB, storeVideoInDB } from '../../utils/indexdb.utils';

interface Props {
  timer?: number;
  onGameEnd?: () => void;
}

const PegaMas: React.FC<Props> = ({ timer, onGameEnd }) => {
  const resultPerPage = 1;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isLotteryClosed, setLotteryCloses] = useState<boolean>(false);
  const [showVideo, setShowVideo] = useState(false);
  const [countMinutes, setCountMinutes] = useState<number | null>(null);
  const [winnerNumbers, setWinnerNumbers] = useState<number[]>([]);
  const [videoSrc, setVideoSrc] = useState<string | null>(null);
  const [lastResult, setLastResult] = useState<string | null>(null);
  const [isFetching, setIsFetching] = useState(false); 
  const { data: { lotteryResults = [], activeLottery, isActive, jackpot }, getResults } = usePegaMas();
  const { getExternalLotteryResults, data: externalData } = usePegaMas();
  const loteryExternalResults = externalData.items || [];

      const ppm = loteryExternalResults.filter((item: any) => item.externalCode === "LJPM")[0] || {};
      const allLotteries = loteryExternalResults.filter((item: any) => item.externalCode !== "LJPM") || [];
      const erP1 = allLotteries.slice(0,9) || [];
      const erP2 = allLotteries.slice(9) || [];      

  useEffect(() => {
    const loadVideo = async () => {
      try {
        let videoBlob = await getVideoFromDB("pegaMas-video");
        if (videoBlob) {
          setVideoSrc(URL.createObjectURL(videoBlob));
        } else {
          const response = await fetch(videoUrls["low"]);
          if (!response.ok) throw new Error("Failed to fetch video");
          const blob = await response.blob();
          setVideoSrc(URL.createObjectURL(blob));
          await storeVideoInDB("pegaMas-video", blob);
        }
      } catch (error) {
        console.error("Error cargando video:", error);
        setVideoSrc(videoUrls["low"]);
      }
    };

    loadVideo();
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (activeLottery) {
      evaluateDates();
    }
  }, [activeLottery]);

  useEffect(() => {
    if (loading || lotteryResults.length === 0) return;

    const currentResult = lotteryResults[0]?.result || null;

    if (!lastResult) {
      setLastResult(currentResult);
      const numbers = currentResult.split('-').map(Number) || [];
      setWinnerNumbers(numbers);
      return;
    }

    if (currentResult !== lastResult) {
      setLastResult(currentResult);
      const numbers = currentResult.split('-').map(Number) || [];
      setWinnerNumbers(numbers);
      setShowVideo(true);
    }
  }, [lotteryResults, loading, lastResult]);

  useEffect(() => {
    if (countMinutes === null || isFetching) return;

    if (countMinutes <= 0) {
      setLoading(true);
      fetchData();
      setCountMinutes(null);
      return;
    }

    const timer = setTimeout(() => {
      setCountMinutes((prev) => (prev !== null ? prev - 1000 : null));
    }, 1000);

    return () => clearTimeout(timer);
  }, [countMinutes, isFetching]);

  const fetchData = async () => {
    setLoading(true);
    setIsFetching(true); 
    setError(null);
    try {
      await getResults(games.PEGAMAS, resultPerPage);
      await getExternalLotteryResults('');
 
    } catch (error) {
      console.error("Error fetching data:", error);
      setError('Error loading data. Please try again.');
    } finally {
      setLoading(false);
      setIsFetching(false);
    }
  };

  const evaluateDates = (): void => {
    if (!isActive) {
      setLotteryCloses(true);
      return;
    }

    const now = new Date();
    const startTime = parseTimeToDate(activeLottery.startTime);
    const closeTime = parseTimeToDate(activeLottery.closeTime);

    const maxAllowedDifference = 10 * 60 * 1000;
    const serverTimeDifference = Math.abs(startTime.getTime() - now.getTime());

    if (serverTimeDifference > maxAllowedDifference) {
      setLotteryCloses(true);
      return;
    }

    if (now > closeTime) {
      setLoading(true);
      fetchData();
    } else {
      setCountMinutes(closeTime.getTime() - now.getTime());
      setShowVideo(false);
    }
  };

  const handleVideoEnd = () => {
    setShowVideo(false);
    if (onGameEnd) onGameEnd();
  };

  if (loading) return <LoadingSpinner />;
  if (error || isLotteryClosed || !activeLottery || !isActive) return <ErrorPage />;

  return (
    <div className="App">
      {showVideo ? (
        <ResultAnimation numbers={winnerNumbers} teardown={handleVideoEnd} videoSrc={videoSrc} />
      ) : (
      <Carousel
        autoPlay
        infiniteLoop
        interval={10000}
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        className="results-carousel0"
        transitionTime={500}
      >
          <div>
            {countMinutes !== null &&
            countMinutes > 0 && <PegaMasResults timeInMilliseconds={countMinutes} jackpot={jackpot.jackpot} isResult={true}/>}
          </div>

          {/* <div>
            {countMinutes !== null &&
            countMinutes > 0 && <PegaMasResults timeInMilliseconds={countMinutes} jackpot={jackpot.jackpot} isResult={false}/>}
          </div>           */}

          <div className="commercial-container">
            <div className="a-commercial4"></div>
          </div>                    

          <div className="lrc">
              <div className="header">
                  <div className="text">Resultados</div>
                  {/* <div className="date">Sábado 21/06/2025</div> */}
              </div>

              <div className="lc-list">
                <ul>
                  {ppm && ppm.result!==undefined && ppm.result.length>0 &&(

                  <li className="pm-lottery">
                      <div className="pegamas5">
                          <div className="result-container">
                              <div  className="pm5-logo" >
                                  <div className="pm5-img" ></div>
                              </div>
                              <div className={ppm.isResultUpdated ? 'pm5-number-results-updated' : 'pm5-number-results'}>
                                <div className="pm5-b">{ppm.result[0]}</div>
                                <div className="pm5-b">{ppm.result[1]}</div>
                                <div className="pm5-r">{ppm.result[2]}</div>
                                <div className="pm5-r">{ppm.result[3]}</div>
                                <div className="pm5-g">{ppm.result[4]}</div>
                              </div>
                          </div>
                          <div className="pm5-footer">
                              <div className="text">{ppm.weekDay} - {ppm.resultDate}</div>
                              <div className="hours">{ppm.time}</div>
                              <div className={ppm.period == 'Night' ? 'icono moon' : 'icono sun'} ></div>
                          </div>
                      </div>
                  </li>
                  )}

                  {erP1.map((result: any, index: number) => (
                    <li className="st-lotteries" key={index} title={result.externalCode}>
                      <div className="lottery-container">
                          <div className="logo-lottery ">
                              <div className={result.externalCode} ></div>
                          </div>
                          <div className='stnc'>
                            <ul className={result.isResultUpdated ? 'st-numbers-updated' : 'st-numbers'}>
                                <li>
                                    <div>{result.result[0]}</div>
                                </li>
                                <li>
                                    <div>{result.result[1]}</div>
                                </li>
                                <li>
                                    <div>{result.result[2]}</div>
                                </li>
                            </ul>
                          </div>
                          <div className="time">
                              <div className="text">{result.weekDay} {result.resultDate}</div>
                              <div className="hours">{result.time}</div>
                              <div className={result.period === 'Night' ? 'icono moon' : 'icono sun'} ></div>
                          </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* <div className="footer">
                  <div className="text">Para más información: (809) 000-0000</div>
              </div> */}
          </div>

          <div className="commercial-container">
            <div className="a-services"></div>
          </div>

          <div>
            <div className="lrc">
                <div className="header">
                    <div className="text">Resultados</div>
                    {/* <div className="date">Sábado 21/06/2025</div> */}
                </div>

                <div className="lc-list">
                  <ul>
                    {erP2.map((result: any, index: number) => (
                      <li className="st-lotteries" key={index} title={result.externalCode}>
                        <div className="lottery-container">
                            <div className="logo-lottery ">
                                <div className={result.externalCode} ></div>
                            </div>
                            <div className='stnc'>
                              <ul className={result.isResultUpdated ? 'st-numbers-updated' : 'st-numbers'}>
                                    <li>
                                        <div>{result.result[0]}</div>
                                    </li>
                                    <li>
                                        <div>{result.result[1]}</div>
                                    </li>
                                    <li>
                                        <div>{result.result[2]}</div>
                                    </li>
                                </ul>
                            </div>
                            <div className="time">
                                <div className="text">{result.weekDay} {result.resultDate}</div>
                                <div className="hours">{result.time}</div>
                                <div className={result.period === 'Night' ? 'icono moon' : 'icono sun'} ></div>
                            </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* <div className="footer">
                    <div className="text">Para más información: (809) 000-0000</div>
                </div> */}
            </div>
          </div> 

          <div className="commercial-container">
            <div className="a-commercial2"></div>
          </div>

          <div className="commercial-container">
            <div className="a-commercial3"></div>
          </div>

          <div className="commercial-container">
            <div className="a-commercial5"></div>
          </div>

          <div className="commercial-container">
            <div className="a-commercial6"></div>
          </div>
      </Carousel>        
      )}
    </div>
  );
};

export default PegaMas;